import React, { useEffect, useState } from 'react';
// استيراد useParams للحصول على معرف المنتج من الرابط، وLink للتنقل، وuseNavigate للتوجيه برمجياً
import { useParams, Link, useNavigate } from 'react-router-dom'; 
// استيراد الكونتكست الخاص بالمنتجات
import { useProducts } from '../../components/Context/ProductContext'; 
// استيراد الكونتكست الخاص بالسلة
import { useCart } from '../Context/Cart'; 

export default function ProductDetails() {
  // الحصول على معرف المنتج من الرابط
  const { id } = useParams();
  // الحصول على قائمة المنتجات وحالة التحميل من الكونتكست
  const { products, loading } = useProducts();
  // حالة لتخزين بيانات المنتج الحالي
  const [product, setProduct] = useState(null);
  // دالة الإضافة للسلة من الكونتكست
  const { addToCart } = useCart();
  // حالة لعرض معلومات إضافية (غير مستخدمة هنا بعد حذف زر Go to Cart)
  const [showProductInfo, setShowProductInfo] = useState(false);
  // تهيئة دالة التوجيه البرمجي لصفحات أخرى
  const navigate = useNavigate();

  // تأثير يتم تنفيذه عند تغير id أو المنتجات أو حالة التحميل
  useEffect(() => {
    if (!loading) { // إذا لم يكن هناك تحميل جاري
      // البحث عن المنتج في القائمة حسب المعرف
      const found = products.find(p => p.id === parseInt(id));
      // تحديث حالة المنتج (إذا لم يُعثر على المنتج، تكون القيمة null)
      setProduct(found || null);
      // إعادة ضبط عرض معلومات المنتج
      setShowProductInfo(false);
    }
  }, [id, products, loading]);

  // أثناء تحميل البيانات، عرض رسالة تحميل
  if (loading) return <h3 className="text-center my-5">Loading...</h3>;
  // إذا لم يُعثر على المنتج، عرض رسالة خطأ
  if (!product) return <h3 className="text-center text-danger my-5">Product not found</h3>;

  // استخراج المنتجات ذات التصنيف نفسه (باستثناء المنتج الحالي)
  const related = products.filter(p => p.category === product.category && p.id !== product.id);

  // دالة لإضافة المنتج للسلة ثم التوجيه لصفحة السلة
  function handleAddToCart() {
    addToCart(product);          // إضافة المنتج للسلة
    navigate('/cart');           // التوجيه إلى صفحة السلة (يمكن تعديل المسار حسب مشروعك)
  }

  return (
    <>
      <div className="container my-5">
        <div className="row">

          {/* عرض صورة المنتج */}
          <div className="col-md-6">
            <div className="text-center">
              <img 
                src={product.image}         // رابط صورة المنتج
                alt={product.title}         // نص بديل للصورة
                className="img-fluid"       // لجعل الصورة متجاوبة
                style={{ maxWidth: '400px', height: 'auto' }}  // تحديد حجم الصورة
              />
            </div>
          </div>

          {/* عرض تفاصيل المنتج */}
          <div className="col-md-6">
            {/* عرض الفئة */}
            <p className="text-muted text-uppercase mb-2" style={{ fontSize: '0.9rem', letterSpacing: '1px' }}>
              {product.category}
            </p>

            {/* عنوان المنتج */}
            <h1 className="mb-3" style={{ fontSize: '2.2rem', fontWeight: '300', lineHeight: '1.2' }}>
              {product.title}
            </h1>

            {/* عرض تقييم المنتج بالنجوم */}
            <div className="d-flex align-items-center mb-3">
              <span className="me-2" style={{ fontSize: '1.1rem' }}>
                {product.rating?.rate}
              </span>
              <div className="text-warning me-2">
                {'★'.repeat(Math.floor(product.rating?.rate || 0))}
                {'☆'.repeat(5 - Math.floor(product.rating?.rate || 0))}
              </div>
            </div>

            {/* سعر المنتج */}
            <h2 className="mb-4" style={{ fontSize: '1.8rem', fontWeight: '400', color: '#333' }}>
              ${product.price}
            </h2>

            {/* وصف المنتج */}
            <p className="mb-4" style={{ fontSize: '1rem', lineHeight: '1.6', color: '#666' }}>
              {product.description}
            </p>

            {/* زر إضافة المنتج إلى السلة */}
            <div className="d-flex gap-3 mb-4">
              <button 
                className="btn btn-outline-dark px-4 py-2"
                style={{ 
                  borderRadius: '0',
                  fontSize: '0.95rem',
                  fontWeight: '400',
                  minWidth: '140px'
                }}
                // عند الضغط، يضيف المنتج للسلة ويوجه لصفحة السلة
               onClick={() => addToCart(product)} >
                Add to Cart
              </button>
            </div>
          </div>
        </div>

        {/* حذفنا عرض معلومات الشراء لأنه مرتبط بزرار Go to Cart */}

        {/* قسم المنتجات ذات الصلة */}
        <div className="mt-5">
          <h4 className="mb-4" style={{ fontSize: '1.5rem', fontWeight: '400' }}>
            Related Products
          </h4>

          <div className="row g-3">
            {related.map(r => (
              <div key={r.id} className="col-md-3">
                <div className="card h-100" style={{ border: '1px solid #eee' }}>
                  <div className="text-center p-3">
                    <img 
                      src={r.image}
                      alt={r.title}
                      style={{ height: '150px', objectFit: 'contain' }}
                      className="img-fluid"
                    />
                  </div>
                  <div className="card-body d-flex flex-column">
                    {/* عنوان المنتج مع اقتطاع طول النص */}
                    <h6 className="card-title mb-2" style={{ fontSize: '0.9rem', lineHeight: '1.3' }}>
                      {r.title.substring(0, 50)}...
                    </h6>

                    {/* سعر المنتج */}
                    <p className="card-text fw-bold mt-auto" style={{ fontSize: '1.1rem' }}>
                      ${r.price}
                    </p>

                    {/* زر لعرض تفاصيل المنتج */}
                    <Link to={`/product/${r.id}`}>
                      <button 
                        className="btn btn-outline-dark btn-sm w-100 mt-2"
                        style={{ borderRadius: '0', fontSize: '0.85rem' }}
                      >
                        View Product
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
